<template>
  <div class="allActiveSch">
    <div class="header">
      <el-row :gutter="1" type="flex">
        <el-col :span="9"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{
              startDate: searchForm.startDate,
              endDate: searchForm.endDate
            }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="6"
          ><span class="title">省市区:</span
          ><el-cascader
            :options="options"
            v-model="cityValue"
            :props="{ multiple: true }"
            collapse-tags
            clearable
            @change="cityChange"
            @visible-change="cityVisible"
            @remove-tag="removeTag"
          ></el-cascader
        ></el-col>
        <el-col :span="6"
          ><span class="title">学校:</span
          ><filterSelect ref="filterSelect" :optionsList="schoolList" @checked="schoolChecked"
        /></el-col>
        <el-col :span="3"
          ><div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search">查询</el-button>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          学校统计
          <el-popover
            placement="bottom-start"
            width="400"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="XXTJ"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="goDetail">教师明细</el-button>
          <el-button type="primary" size="small" @click="downExcel" :loading="downLoading">导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          :key="'allActiveSch' + keytable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'totalTeaNum', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column fixed type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed label="学校名称" width="220">
            <template slot-scope="scope">
              <span class="schName" @click="goSch(scope.row)">{{ scope.row.schoolName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalTeaNum" label="教师总数" min-width="110" sortable="custom"> </el-table-column>
          <el-table-column prop="alreadyLoggedNum" label="登录教师数" min-width="110" sortable="custom">
          </el-table-column>
          <el-table-column
            prop="alreadyLoggedPercent"
            label="教师登录率"
            min-width="110"
            sortable="custom"
          ></el-table-column>
          <el-table-column prop="activeTeaNum" label="活跃教师数" min-width="110" sortable="custom"></el-table-column>
          <el-table-column
            prop="activeTeaNumPercent"
            label="教师活跃率"
            min-width="110"
            sortable="custom"
          ></el-table-column>
          <el-table-column prop="functionUse" label="功能使用度" min-width="110" sortable="custom"></el-table-column>
          <el-table-column prop="lesson" label="备课" min-width="110" sortable="custom"></el-table-column>
          <el-table-column prop="classLesson" label="上课" min-width="110" sortable="custom"></el-table-column>
          <el-table-column prop="tasks" label="作业" min-width="110" sortable="custom"></el-table-column>
          <el-table-column prop="aiCard" label="智能卡" min-width="110" sortable="custom"></el-table-column>
        </el-table>
      </div>
      <div class="pagSize">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import filterSelect from '../../components/FilterSelect/index.vue'
import datePicker from '../../components/datePicker/index.vue'
import { lastWeek } from '@/utils/date.js'
import { XXTJ } from '@/utils/explainText.js'
// import { saveAs } from "file-saver";
import fileSave from '@/utils/fileSave.js'

import { allActiveScl } from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import { resize } from '@/mixins/resize.js'
export default {
  name: 'AllActiveSch',
  mixins: [resize],
  components: {
    filterSelect,
    datePicker
  },
  data() {
    return {
      XXTJ: XXTJ,
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      options: JSON.parse(sessionStorage.getItem('cityList')),
      cityValue: [],
      searchForm: {
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key,
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        pageSize: 12,
        pageNum: 1,
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        schoolIds: [],
        sortCode: 'totalTeaNum',
        ascOrDes: false //false是降序,true是升序
      },
      address: {
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      emptyIsShow: false,
      tableData: [{ test: 111 }],
      keytable: 0,
      loading: false,
      total: 0,
      downLoading: false
    }
  },
  created() {
    this.getSchoolList()
  },
  methods: {
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
    },
    cityChange(v) {
      console.log(v)
      this.address = this.$options.data().address
      this.searchForm.provinceIds = this.searchForm.cityIds = this.searchForm.localeIds = []
      if (v.length < 1) {
        this.getSchools()
      }
      v.forEach((el) => {
        this.address.provinceIds.push(el[0])
        this.searchForm.provinceIds = this.address.provinceIds
        this.address.cityIds.push(el[1])
        this.searchForm.cityIds = this.address.cityIds
        this.address.localeIds.push(el[2])
        this.searchForm.localeIds = this.address.localeIds
      })
    },
    // 省市区选择器收起时
    cityVisible(v) {
      if (!v && this.address.provinceIds.length > 0) {
        // console.log("请求");
        this.getSchools()
      }
    },
    removeTag(v) {
      // console.log(v);
      let i = this.address.provinceIds.findIndex((el) => el == v[0])
      this.address.provinceIds.splice(i, 1)
      this.address.cityIds.splice(i, 1)
      this.address.localeIds.splice(i, 1)
      if (this.address.provinceIds.length > 0) {
        this.getSchools()
      }
    },
    schoolChecked(v) {
      this.searchForm.schoolIds = []
      v.forEach((el) => {
        this.searchForm.schoolIds.push(el.value)
      })
    },
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.$refs.filterSelect.checkedValue = ''
      this.cityValue = []
      this.address = this.$options.data().address
      this.keytable += 1
      this.schoolList = JSON.parse(sessionStorage.getItem('schoolList'))
      this.getSchoolList()
    },
    search() {
      this.searchForm.pageNum = 1
      this.getSchoolList()
    },
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending' ? (this.searchForm.ascOrDes = false) : (this.searchForm.ascOrDes = true)
        this.getSchoolList()
      }
    },
    handleSizeChange(v) {},
    handleCurrentChange(v) {
      this.searchForm.pageNum = v
      this.getSchoolList()
    },
    goDetail() {
      let obj = {
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        cityValue: this.cityValue,
        address: this.address,
        schoolIds: this.searchForm.schoolIds
      }
      this.$router.push({
        name: 'AllActiveTecDetail',
        query: {
          info: JSON.stringify(obj)
        }
      })
    },
    downExcel() {
      this.downLoading = true

      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum
      obj.fileName = excelName('学校教师活跃分析', obj.startDate, obj.endDate)

      fileSave(allActiveScl + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
        this.downLoading = false
      })
    },
    goSch(v) {
      let obj = {
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        schoolId: v.schoolId,
        schoolName: v.schoolName
      }
      this.$router.push({
        name: 'AllActiveGradeSubAct',
        query: {
          info: JSON.stringify(obj)
        }
      })
    },
    // 获取表格日常数据
    getSchoolList() {
      this.loading = true
      this.$API.allActiveSchApi
        .getSchoolList(this.searchForm)
        .then((res) => {
          // console.log(res);
          this.tableData = res.result
          if (this.tableData.length > 0) {
            this.total = this.tableData[0].total
            this.tableData.forEach((el) => {
              el.alreadyLoggedPercent = el.alreadyLoggedPercent + '%'
              el.activeTeaNumPercent = el.activeTeaNumPercent + '%'
            })
          } else {
            this.total = 0
          }

          // console.log(this.tableDataHomework);
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取学校列表
    getSchools() {
      this.$API.basicsApi.getSchoolList(this.address).then((res) => {
        console.log(res)
        this.searchForm.schoolIds = []
        this.$refs.filterSelect.checkedValue = ''
        this.schoolList = res.result.map((el) => {
          el.label = el.schoolName
          el.value = el.schoolId
          delete el.schoolId
          delete el.schoolName
          delete el.total
          return el
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.allActiveSch {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
      ::v-deep .schName {
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
